export enum TextColor {
    white = 'text-white',
    gray = 'text-gray-900',
}
